// Merge fields and limits mirror the Text/Email Template modals and the sequence validation schema

export const MERGE_FIELDS = [
    { key: 'first_name', value: '%%First Name%%', text: 'Contact: First Name' },
    { key: 'last_name', value: '%%Last Name%%', text: 'Contact: Last Name' },
    { key: 'full_name', value: '%%Full Name%%', text: 'Contact: Full Name' },
    { key: 'phone', value: '%%Phone%%', text: 'Contact: Phone' },
    { key: 'address', value: '%%Address%%', text: 'Contact: Address' },
    { key: 'city', value: '%%City%%', text: 'Contact: City' },
    { key: 'state', value: '%%State%%', text: 'Contact: State' },
    { key: 'zip', value: '%%Zip%%', text: 'Contact: Zip' },
    { key: 'my_full_name', value: '%%My Full Name%%', text: 'Me: Full Name' },
    { key: 'my_first_name', value: '%%My First Name%%', text: 'Me: First Name' },
    { key: 'my_phone', value: '%%My Phone%%', text: 'Me: Phone' },
    { key: 'my_company', value: '%%My Company%%', text: 'Me: Company' }
];

const KNOWN_MERGE_FIELDS = MERGE_FIELDS.map(({ value }) => value);

export const getUnknownMergeFields = (text = '') => (text.match(/%%[^%]+%%/g) || []).filter(field => !KNOWN_MERGE_FIELDS.includes(field));

export const TEXT_CHARACTER_LIMIT = 160;

export const getTextSegmentCount = (message = '') => Math.max(1, Math.ceil(message.length / TEXT_CHARACTER_LIMIT));

export const hasOptOutLanguage = (message = '') => /\bSTOP\b/.test(message);

export const SEQUENCE_STEP_TYPES = [
    { key: 'call', value: 'call', text: 'Call', icon: 'phone' },
    { key: 'text', value: 'text', text: 'Text', icon: 'comment alternate outline' },
    { key: 'email', value: 'email', text: 'Email', icon: 'mail outline' }
];

export const DELIVER_OPTIONS = [
    { key: 'instant', value: 'instant', text: 'Immediately' },
    { key: 'minutes', value: 'minutes', text: 'Minutes' },
    { key: 'hours', value: 'hours', text: 'Hours' },
    { key: 'days', value: 'days', text: 'Days' },
    { key: 'weeks', value: 'weeks', text: 'Weeks' },
    { key: 'months', value: 'months', text: 'Months' }
];

export const MAX_TIME_AMOUNT = { minutes: 60, hours: 24, days: 15, weeks: 8, months: 12 };

export const MAX_STEPS_PER_TYPE = 5;

// Units long enough that the step also needs a time of day
export const UNITS_WITH_TIME = ['days', 'weeks', 'months'];

export const describeStepTiming = ({ deliver, timeamount, time }, formatTime) => {
    if (deliver === 'instant') {
        return 'Immediately';
    }
    const unit = timeamount === 1 ? deliver.replace(/s$/, '') : deliver;
    return `After ${timeamount} ${unit}${UNITS_WITH_TIME.includes(deliver) ? ` at ${formatTime(time)}` : ''}`;
}
